module.exports = __webpack_public_path__ + "static/media/fontview_110.d2cabc7b.ico";